import { Box } from '@fozito/common-ui';
import styled from 'styled-components';
import HeaderActions from '../HeaderActions';
import CategoriesList from './CategoriesList';
import InputSearchProducts from './InputSearch';
import { Form } from 'antd';
import ProductsList from './ProductsList';
import { cashierScannerCtrl } from '../cashier.controller';
import CashierPromotionNew from '../features/PromotionNew';
import CashierReOrdering from '../features/ReOrdering';
import cashierService from 'modules/POS/services';

const CashierProducts = () => {
  const promotion = cashierService.selectors.promotion();
  const products = cashierService.selectors.products();
  return (
    <Container>
      <HeaderActions />
      <Box display='flex' alignItems='center'>
        <Form.Item name="items" noStyle>
          <InputSearchProducts ref={cashierScannerCtrl} />
        </Form.Item>
        <Box display='flex' alignItems='center' gap={8} marginRight={16}>
          <CashierPromotionNew />
          <CashierReOrdering />
        </Box>
      </Box>
      <Box display={!promotion.active ? 'none' : 'flex'} flex={1} flexDirection='column'>
        <Box flex={1} position='relative' marginRight={8}>
          <Box position='absolute' inset={0} overflowY='auto' overflowX='hidden'>
            <Form.Item name="items" noStyle>
              <ProductsList products={promotion.data} />
            </Form.Item>
          </Box>
        </Box>
      </Box>
      <Box display={promotion.active ? 'none' : 'flex'} flex={1} flexDirection='column'>
        <CategoriesList />
        <Box flex={1} position='relative' marginRight={8}>
          <Box position='absolute' inset={0} overflowY='auto' overflowX='hidden'>
            <Form.Item name="items" noStyle>
              <ProductsList products={products} />
            </Form.Item>
          </Box>
        </Box>
      </Box>
    </Container>
  );
};

export default CashierProducts;

const Container = styled.div`
  background: #5FA9B6;
  display: flex;
  flex-direction: column;
`;
